import { faExternalLinkAlt, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GridApi } from 'ag-grid-community';
import type { JSX } from 'react';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { homebaseBaseUrl } from '@/utils/homebaseLink';

import { BillingReportRow } from '../../types';

export function FullNameGridCell({
  data,
  api
}: {
  data?: BillingReportRow;
  api: GridApi<BillingReportRow>;
}): JSX.Element | null {
  const { host } = useContext(AppContext);

  if (!data) {
    return null;
  }

  const filterToPerson = () => {
    if (api) {
      api.setFilterModel({
        full_name: {
          type: 'contains',
          filter: data.full_name
        }
      });
    }
  };

  return (
    <span>
      <button className="mp-sensitive text-blue-600 hover:text-blue-800" onClick={filterToPerson}>
        {data.full_name}
      </button>
      <a
        href={`${homebaseBaseUrl(host)}/agent/people/${data.person_id}/`}
        target="_blank"
        className="ml-2 h-3 w-3 text-blue-600 hover:text-blue-800 text-xs"
        rel="noreferrer">
        <FontAwesomeIcon icon={faExternalLinkAlt} />
      </a>
      <a
        href={`${homebaseBaseUrl(host)}/agent/audit_logs/billingitem/${data.billing_item_id}`}
        target="_blank"
        className="ml-2 h-3 w-3 text-blue-600 hover:text-blue-800 text-xs"
        rel="noreferrer">
        <FontAwesomeIcon icon={faClock} />
      </a>
    </span>
  );
}
